import { addDays } from "date-fns";

/** Days after the send on which an automatic relaunch leaves, while a required piece is missing. */
export const RELANCE_OFFSETS = [5, 12, 21] as const;

export type RelanceStep = {
  /** The J+n label, e.g. 5 for "J+5". */
  days: number;
  at: Date;
  /** Already left. */
  done: boolean;
  /** The one the jurist is actually waiting on — at most one step carries it. */
  next: boolean;
};

/**
 * The relance calendar for a send, resolved against a moment.
 *
 * The section used to print the policy ("relances à J+5, J+12 et J+21"), which every jurist already
 * knows. What none of them could answer without a calendar is when the next one leaves — so the
 * dates are computed and the pending one is marked.
 *
 * A manual relaunch re-sends, which moves `sentAt` forward: the schedule is always read off the
 * LAST send, never the first.
 */
export function relanceSchedule(sentAt: string | Date, now: Date = new Date()): RelanceStep[] {
  const sent = typeof sentAt === "string" ? new Date(sentAt) : sentAt;

  const steps = RELANCE_OFFSETS.map((days) => ({ days, at: addDays(sent, days) }));
  const nextIndex = steps.findIndex((step) => step.at.getTime() > now.getTime());

  return steps.map((step, index) => ({
    ...step,
    // Every offset is behind us once none is still ahead.
    done: nextIndex === -1 || index < nextIndex,
    next: index === nextIndex,
  }));
}
